import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Sidebar from './Sidebar'

export default function Layout() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="page page-center">
        <div className="container container-tight py-4 text-center">
          <div className="spinner-border text-primary" role="status" />
          <p className="mt-3 text-secondary">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  return (
    <div className="page">
      <Sidebar />
      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-xl animate-in">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
